import { getListOfGatewayAndPriceWhatsapp, getListOfWhatsappPrice2, editWhatsappPrice2 } from "../types/gateway_and_price_list_whatsapp_types";

export const getListOfGatewayAndPriceWhatsappRequest = (payload, cb) => ({
  type: getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_REQUEST,
  payload,
  cb,
});
export const getListOfGatewayAndPriceWhatsappSuccess = (payload) => ({
  type: getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_SUCCESS,
  payload,
});
export const getListOfGatewayAndPriceWhatsappError = (payload) => ({
  type: getListOfGatewayAndPriceWhatsapp.GET_LIST_OF_GATEWAY_AND_PRICE_WHATSAPP_ERROR,
  payload,
});

export const getListOfWhatsappPrice2Request = (payload, cb) => ({
  type: getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_REQUEST,
  payload,
  cb,
});
export const getListOfWhatsappPrice2Success = (payload) => ({
  type: getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_SUCCESS,
  payload,
});
export const getListOfWhatsappPrice2Error = (payload) => ({
  type: getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_ERROR,
  payload,
});

export const editWhatsappPrice2Request = (payload, cb) => ({
  type: editWhatsappPrice2.EDIT_WHATSAPP_PRICE_2_REQUEST,
  payload,
  cb,
});
export const editWhatsappPrice2Success = (payload) => ({
  type: editWhatsappPrice2.EDIT_WHATSAPP_PRICE_2_SUCCESS,
  payload,
});
export const editWhatsappPrice2Error = (payload) => ({
  type: editWhatsappPrice2.EDIT_WHATSAPP_PRICE_2_ERROR,
  payload,
});
